export default __webpack_public_path__ + "static/media/KZ.T.10.2072.81ed6bf0.svg";